import service from '@/services/produccion/order'

const order = {
  emisor: { id: '' },
  consecutivo: '',
  sequence: 0,
  status: 'CREADO',
  user: {},
  startDate: null,
  endDate: null,
  createdAt: null,
  itemOrder: []
}

const getDefaultState = () => ({
  order,
  list: [],
  production: [],
  pageInfo: {},
  currentRow: null,
  totalRegistros: 0,
  isListening: false
})

export const state = () => getDefaultState()

export const mutations = {
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  RESET: state => {
    state.order = {
      emisor: { id: '' },
      consecutivo: '',
      sequence: 0,
      status: 'CREADO',
      user: {},
      startDate: null,
      endDate: null,
      createdAt: null,
      itemOrder: []
    }
  },
  SET_ROW: (state, row) => (state.currentRow = row),
  SET_LIST: (state, obj) => {
    state.list = [...new Set([...state.list.map(JSON.stringify), ...obj.feed.map(JSON.stringify)])].map(JSON.parse)
    state.pageInfo = obj.pageInfo
  },
  UPDATE_LIST: (state, obj) => {
    const nObj = state.list.find(e => e._id === obj._id)
    if (!nObj) state.list = [obj, ...state.list]
    else Object.keys(nObj).forEach(i => (nObj[i] = obj[i]))

    state.saved = true
  },
  SET_LIST_BY_DATE: (state, obj) => {
    state.list = obj.feed
    state.pageInfo = obj.pageInfo
  },
  SET: (state, obj) => {
    state.order = obj
  }
}

export const actions = {
  resetList: ({ state }) => {
    state.list = []
    state.pageInfo = {}
  },
  readTotal: async ({ state, rootGetters }) =>
    service.readTotal(await rootGetters['facturacion/emisorStore/get_Id']).then(response => {
      state.totalRegistros = response
    }),
  readAllByEmisor: async ({ commit, state, dispatch, rootGetters }, { restart = false, limit = 10, filter = null }) => {
    if (restart) await dispatch('resetList')

    // manufactura, reventa, consumible: tipoProducto === '02' - '03' - '04'
    return service.readAllByEmisor(rootGetters['facturacion/emisorStore/get_Id'], state.pageInfo.nextPageCursor, limit, filter).then(response => {
      console.log('Produccion from server 🤖')

      if (!state.isListening) {
        state.isListening = true

        dispatch('subscriptionNewOrder')
      }

      return commit('SET_LIST', response)
    })
  },
  readBySearchString: async ({ state, rootGetters }, { searchString }) =>
    service.readBySearchString(rootGetters['facturacion/emisorStore/get_Id'], searchString),

  readByDateRange: async ({ commit, dispatch, rootGetters }, { inicio, final }) => {
    await dispatch('resetList')

    return service.readByDateRange(rootGetters['facturacion/emisorStore/get_Id'], inicio, final).then(result => {
      return commit('SET_LIST_BY_DATE', result)
    })
  },
  create: async ({ dispatch, rootGetters }, { _idEmisor, input, refreshList = true }) => {
    return service
      .create({
        _id: input._id,
        _idDoc: input._idDoc,
        consecutivo: input.consecutivo,
        factura: input.factura,
        _idFactura: input._idFactura,
        startDate: input.startDate,
        endDate: input.endDate,
        status: input.status,
        user: input.user,
        ...(input.receptor && { receptor: { _id: input.receptor.id || input.receptor._id } }),
        emisor: {
          _id: (await rootGetters['facturacion/emisorStore/get_Id']) || _idEmisor
        }
      })
      .then(result => {
        if (refreshList) dispatch('readAllByEmisor', { restart: true })

        // commit('UPDATE_LIST', {
        //   ...input,
        //   _id: result
        // })

        return result
      })
  },
  readById: async ({ commit }, { _id, row }) =>
    service.readById(_id).then(response => {
      commit('SET', { ...row, ...response })
      return response
    }),
  subscriptionNewOrder: ({ commit, rootGetters }) => {
    service.subscriptionNewOrder(
      rootGetters['facturacion/emisorStore/get_Id'],

      result => commit('UPDATE_LIST', result)
    )
  }
}
